<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search search_box">
                <el-form :model="searchForm"
                 inline
                  size="small" 
                @keyup.native.enter="submitForm">
                    <el-form-item>
                        <el-input class="width_300" 
                        @change="searchNow()" 
                        placeholder="请输入关键字"
                            v-model="searchForm.name"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="searchNow()" plain type="primary">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="table form_main">
            <div class="item left_form">
                <div class="title">基本信息</div>
                <div v-for="(item, index) in form_columns" :key="index">
                    <div class="cell" v-if="form[item.prop]">
                        <div class="cell_t">{{ item.label }}：</div>
                        <div class="cell_m">
                            <span v-if="item.showDrug" v-text="showDrugText(form.drug_code)"></span>
                            <span v-else-if="item.showSex">
                                <span v-if="form.sex == 1">男</span>
                                <span v-else>女</span>
                            </span>
                            <span v-else>
                                <span>{{ form[item.prop] }}</span>
                                <span v-if="item.prop2 && form[item.prop2]">{{ form[item.prop2] }}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item right_log">
                <div class="title">跟进记录</div>
                <div class="log_box">
                    <div class="log" v-for="(item, index) in drugLogs" :key="index">
                        <div class="name">跟进记录{{ index + 1 }}：</div>
                        <div class="cell">
                            <div class="cell_t">购买日期：</div>
                            <div class="cell_m">{{ item.cycle_date }}</div>
                        </div>
                        <div class="cell">
                            <div class="cell_t">数量：</div>
                            <div class="cell_m">
                                <el-input-number v-model="item.medication_count"
                                 :min="0" />
                            </div>
                        </div>
                        <div class="cell">
                            <div class="cell_t">类别：</div>
                            <div class="cell_m">
                                <el-select v-model="item.medication_type"
                                    class="width_300"
                                >
                                    <el-option v-for="(item, index) in type_options"
                                        :key="index"
                                        :label="item"
                                        :value="item"
                                    ></el-option>
                                </el-select>
                            </div>
                        </div>
                        <!-- <div class="cell">
                            <div class="cell_t">本次注射频率：</div>
                            <div class="cell_m">{{ item.medication_cycle_days }}</div>
                        </div>
                        <div class="cell">
                            <div class="cell_t">下次购买日期：</div>
                            <div class="cell_m">{{ item.next_medication_date }}</div>
                        </div> -->
                    </div>
                </div>
                <div class="bottom_btn" v-if="drugLogs.length > 0">
                    <el-button type="primary" 
                    :disabled="btn_dis" 
                    @click="submitNow">提交</el-button>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    name: "DataRecovery",
    data() {
        return {
            searchForm: {
                name: ''
            },
            search_timer: null,

            form: {},
            drugLogs: [],
            btn_dis: false,

            form_columns: [
                { label: '拜访类别', prop: 'drug_code', showDrug: true },
                { label: '拜访编码', prop: 'patient_id' },
                { label: '拜访对象', prop: 'patient_name' },
                { label: '性别', prop: 'sex', showSex: true },
                { label: '拜访代码', prop: 'patient_phone' },
                { label: '拜访城市', prop: 'province', prop2: 'city' },
                { label: '拜访医院', prop: 'hospital' },
                { label: '拜访科室', prop: 'department' },
                { label: 'HCP', prop: 'doctor_name' },
                { label: '首次购买日期', prop: 'first_drug_date' },
                { label: '适应症', prop: 'disease' },
                { label: '病种', prop: 'tumour', prop2: 'tumour_mark' },
                { label: '年龄段', prop: 'stage' },
                { label: '启用时机', prop: 'line_number' },
                { label: '推荐DOT', prop: 'recommended_dot' },
                { label: '跟进人', prop: 'fill_user_info' },
                { label: '治疗方案', prop: 'schedule', prop2: 'schedule_mark' },
            ]
        };
    },
    computed: {
        ...mapState('comInformationData', [
            'drug_code_list',
            'medication_fields_conf'
        ]),
        type_options() {
            let drug = this.form.drug_code || '';
            let options = this.medication_fields_conf.default_options
            let default_options = this.medication_fields_conf.default_options
            if(drug && this.medication_fields_conf[drug]) {
                options = this.medication_fields_conf[drug]
            }
            return options.drug_type_list || default_options.drug_type_list
        }
    },
    mounted() {
    },
    methods: {
        showDrugText(code) {
            let item = this.drug_code_list.filter(v => v.drug_code == code)[0];
            console.log(item, code, 'code');

            return item.name || ''
        },
        submitForm(e) {
            e.preventDefault(); // 阻止默认提交行为
        },

        searchNow() {
            if (this.search_timer) {
                clearTimeout(this.search_timer);
                this.search_timer = null;
            }
            this.search_timer = setTimeout(() => {
                this.getForm();
            }, 100);
        },
        getForm() {
            let params = {
                patient_id: this.searchForm.name
            }
            if (!params.patient_id) {
                this.form = {};
                return
            }
            this.httpGet('/user/get_patient', params).then(res => {
                this.form = res.data.rep_patient;
                this.drugLogs = this.form.medications;
            })
        },
        submitNow() {
            this.btn_dis = true;
            let params = {
                patient_id: this.form.patient_id,
                medications: this.drugLogs
            }
            this.httpPost('/user/patient/modify', params).then(res => {
                // this.form = {};
                // this.searchForm.name = '';
                // this.drugLogs = [];
                this.btn_dis = false;
                this.$message.success('提交成功！');
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.context {
    width: 100%;
    height: 100%;

    .form_main {
        display: flex;
        height: calc(100% - 60px);

        .item {
            height: 100%;
            .title {
                font-size: 16px;
                line-height: 40px;
                font-weight: 600;
                padding-left: 20px;
            }

            .cell {
                line-height: 40px;
                display: flex;
                align-items: center;

                .cell_t {
                    min-width: 120px;
                    box-sizing: border-box;
                    padding-right: 5px;
                    text-align: right;
                    font-size: 14px;
                    color: #555;
                }
            }
        }

        .left_form {
            flex: 2;
            border-right: 1px solid #f4f4f4;
            overflow-y: auto;
        }

        .right_log {
            flex: 3;
            height: 100%;

            .log_box {
                max-height: calc(100% - 100px);
                overflow-y: auto;
                .log {
                    box-sizing: border-box;
                    padding-left: 40px;
                    .cell {
                        margin-bottom: 15px;
                    }
                }
                .name {
                    font-size: 16px;
                    color: #F56C6C;
                }
            }
            .bottom_btn {
                height: 60px;
                padding: 0 40px 0 100px;
                display: flex;
                align-items: center;
            }

            
        }
    }
}
</style>